export const ID_TOKEN_LOGIN = "ID_TOKEN_LOGIN";
export const USER_INFO_LOGIN = "USER_INFO_LOGIN";